/* eslint-disable no-undef */
export default {
	name: "order-items-compartment-assigning-table",
	props: ["orderId", "orderDeliveryId", "vehicleId", "compartmentsAssigned", "viewOnly", "orderDeliveryVehicleCompartmentProductsSummary"],
	emits: ["assignCompartments"],
	data() {
		return {
			orderItems: [],
			grandTotal: 0,
			orderItemsHeadings: [
				{
					text: "Product",
					field: "product"
				},
				{
					text: "Total Amount Assigned",
					field: "totalAmountAssigned"
				},
				{
					text: "Total Amount Unassigned",
					field: "totalAmountUnassigned"
				},
				{
					text: "Dispensed Amount",
					field: "dispensedQuantity"
				},
				{
					text: "Assigned Compartments",
					field: "assignedCompartments"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			filter:{
				searchQuery: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			newAssignedCustomers: [],
			newUnassignedCustomers: [],
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			canAssignCompartments: null,
			loading: false,
			compartmentProductsSummary: []
		};
	},
	methods: {
		getOrderItems() {
			this.canAssignCompartments = null;
			let request = {
				orderId: this.orderId,
				orderDeliveryId: this.orderDeliveryId,
				vehicleId: this.vehicleId
			};
			orderService.getOrderItemsAssignedCompartments(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.orderItems = successResponse.data.orderItemAssignedCompartments;
						this.orderItems = dataTableHelper.castObjectValues(this.orderItems);
						this.canAssignCompartments = successResponse.data.canAssignProductsToVehicleCompartments;
						if(!this.viewOnly) {
							this.updateOrderItemAssignedCompartments();
						}
						else{
							this.updateOrderItemAssignedCompartmentsViewOnly();
						}
						for(let i = 0; i < this.compartmentProductsSummary.length; i++){
							this.compartmentProductsSummary[i].isViewable = this.orderItems.some(orderItem => orderItem.productId === this.compartmentProductsSummary[i].productId);
						}
						// for(var i = 0; i < this.orderItems.length; i++){
						// 	this.orderItems[i].priceAsString = currencyHelper.numberToCurrency(this.orderItems[i].unitPrice);
						// 	this.orderItems[i].totalAsString = currencyHelper.numberToCurrency(this.orderItems[i].totalAmount);
						// 	this.orderItems[i].totalAmountDispensedAsString = currencyHelper.numberToCurrency(this.orderItems[i].totalAmountDispensed);
						// 	this.orderItems[i].discountedAmountAsString = "";
						// 	this.orderItems[i].priceAfterDiscount = 0;
						// 	this.orderItems[i].priceAfterDiscountAsString = "";
						// 	this.orderItems[i].totalDiscountAmount = 0;
						// 	this.orderItems[i].totalDiscountAmountAsString = "";
						// 	if(this.orderItems[i].discountedAmount !== null && this.orderItems[i].discountedAmount > 0){
						// 		this.orderItems[i].totalDiscountAmount = this.orderItems[i].quantity * this.orderItems[i].discountedAmount;
						// 		this.orderItems[i].totalDiscountAmountAsString = currencyHelper.numberToCurrency(this.orderItems[i].totalDiscountAmount);
						// 		this.orderItems[i].discountedAmountAsString = currencyHelper.numberToCurrency(this.orderItems[i].discountedAmount);
						// 		this.orderItems[i].priceAfterDiscount = this.orderItems[i].totalAmount - this.orderItems[i].totalDiscountAmount;
						// 		this.orderItems[i].priceAfterDiscountAsString = currencyHelper.numberToCurrency(this.orderItems[i].priceAfterDiscount);
						// 	}
						// 	// if(this.orderItems[i].discountedAmount !== null && this.orderItems[i].discountedAmount > 0){
						// 	// 	this.grandTotal += this.orderItems[i].totalAmount - this.orderItems[i].discountedAmount;
						// 	// }
						// 	//this.orderItems[i].TotalAmountDispensed = "$" + this.orderItems[i].totalDispensed;
						// 	//TODO: get from api
						// 	this.orderItems[i].totalAmountAssigned = 0;
						// 	this.orderItems[i].totalAmountUnassigned = 0;
						// 	this.orderItems[i].assignedCompartments = "";
						// }
						console.log("orderItems", this.orderItems);
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		updateOrderItemAssignedCompartments(){
			if(this.compartmentsAssigned !== null && this.compartmentsAssigned.length > 0){
				for(var i = 0; i < this.orderItems.length; i++){
					this.orderItems[i].totalAmountAssigned = 0;
					this.orderItems[i].totalAmountUnassigned = this.orderItems[i].quantity;
					this.orderItems[i].assignedCompartments = "";
				}
				for(let i = 0; i < this.compartmentsAssigned.length; i++){
					for(let j = 0; j < this.compartmentsAssigned[i].selectedCompartments.length; j++) {
						var orderItem = this.orderItems.find(orderItem => 
							orderItem.productId === this.compartmentsAssigned[i].selectedCompartments[j].compartmentProduct.productId
							&& orderItem.orderId === this.compartmentsAssigned[i].orderId);
						console.log("orderItem", orderItem);
						if(orderItem !== null && orderItem !== undefined){
							orderItem.totalAmountAssigned += this.compartmentsAssigned[i].selectedCompartments[j].assignedAmount;
							orderItem.totalAmountUnassigned = (orderItem.quantity - orderItem.totalAmountAssigned);
							orderItem.assignedCompartments = orderItem.assignedCompartments === "" ? this.compartmentsAssigned[i].selectedCompartments[j].compartmentName : orderItem.assignedCompartments+", "+this.compartmentsAssigned[i].selectedCompartments[j].compartmentName;
						}
					}

				}
				console.log("this.orderItems", this.orderItems);
			}
		},
		updateOrderItemAssignedCompartmentsViewOnly(){
			if(this.compartmentsAssigned !== null && this.compartmentsAssigned.length > 0){
				for(var i = 0; i < this.orderItems.length; i++){
					this.orderItems[i].totalAmountAssigned = 0;
					this.orderItems[i].totalAmountUnassigned = this.orderItems[i].quantity;
					this.orderItems[i].assignedCompartments = "";
				}
				for(let i = 0; i < this.compartmentsAssigned.length; i++){
					let orderItemSelected = this.orderItems.find(orderItem =>
						orderItem.productId === this.compartmentsAssigned[i].productId
						&& orderItem.orderId === this.compartmentsAssigned[i].orderId);
					if(orderItemSelected !== null && orderItemSelected !== undefined){
						orderItemSelected.dispensedQuantity = orderItemSelected.dispensedQuantity === null || orderItemSelected.dispensedQuantity === undefined ? 0 : orderItemSelected.dispensedQuantity;
						
						console.log("orderItemSelected.dispensedQuantity", orderItemSelected.dispensedQuantity);
						orderItemSelected.totalAmountAssigned += this.compartmentsAssigned[i].instructedQuantity;
						orderItemSelected.totalAmountUnassigned = (orderItemSelected.quantity - orderItemSelected.totalAmountAssigned);
						orderItemSelected.assignedCompartments = orderItemSelected.assignedCompartments === "" ? this.compartmentsAssigned[i].vehicleCompartmentName : orderItemSelected.assignedCompartments+", "+this.compartmentsAssigned[i].vehicleCompartmentName;
						orderItemSelected.dispensedQuantity = orderItemSelected.dispensedQuantity === null ? 0 : orderItemSelected.dispensedQuantity + this.compartmentsAssigned[i].dispensedQuantity;
					}
				}
			}
		},
		onAssignCompartmentsClick(orderItemId){
			var orderItem = this.orderItems.find(orderItem => orderItem.orderItemId === orderItemId);
			this.$emit("assignCompartments", orderItem);
		},
		convertPercentageToTwoDecimalPlaces(value){
			return value.toFixed(2);
		}
	},
	mounted: function () {
        
	},
	watch:{
		orderId:{
			handler: function () {
				console.log("orderId", this.orderId);
				if((this.orderId !== null && this.orderId > 0) && (this.vehicleId !== null && this.vehicleId > 0)){
					this.getOrderItems();
				}
			},
			immediate: true,
			deep: true
		},
		vehicleId:{
			handler: function () {
				console.log("vehicleId", this.vehicleId);
				if(this.vehicleId !== null && this.vehicleId > 0){
					this.getOrderItems();
				}
			},
			immediate: true,
			deep: true
		},
		// orderTotal:{
		// 	handler: function () {
		// 		console.log("orderTotal", this.orderTotal);
		// 		if(this.orderTotal !== null){
		// 			this.grandTotal = this.orderTotal;
		// 		}
		// 	},
		// 	immediate: true,
		// 	deep: true
		// }
		compartmentsAssigned:{
			handler: function () {
				if(!this.viewOnly){
					this.updateOrderItemAssignedCompartments();
				}
				else{
					this.updateOrderItemAssignedCompartmentsViewOnly();
				}
				
			},
			immediate: true,
			deep: true
		},
		orderDeliveryVehicleCompartmentProductsSummary:{
			handler: function () {
				this.compartmentProductsSummary = this.orderDeliveryVehicleCompartmentProductsSummary;
				if((this.orderId !== null && this.orderId > 0) && (this.vehicleId !== null && this.vehicleId > 0)){
					this.getOrderItems();
				}
			},
			immediate: true,
			deep: true
		}
		
	}
};
